module.exports = __webpack_public_path__ + "img/icon_staff_management.08c38886.png";